import { render, staticRenderFns } from "./SDAExhaustedProducts.vue?vue&type=template&id=f8cbfde2"
import script from "./SDAExhaustedProducts.vue?vue&type=script&lang=js"
export * from "./SDAExhaustedProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports